import defaultLogo from '#/assets/spogen.ai_logo_nega_rgb.svg';
import defaultAvatar from '#/assets/how-do-i-honk.png';
import defaultPoweredByLogo from '#/assets/spogen_logo_no_arcs.svg';
import { ResolvedBranding } from './types';

export const DEFAULT_BRANDING: ResolvedBranding = {
  colors: {
    primary: '#af1260',
    accent: '#19accd',
    gradientFrom: '#162CF4',
    gradientTo: '#af1260',
    background: '#121212',
    messageBackground: '#373737',
    text: '#fcfcfc',
    aiMessageText: '#fcfcfc',
    userMessageBackground: '#fcfcfc',
    userMessageText: '#000000',
    promptBackground: '#2f2f2f',
    promptText: '#fcfcfc',
    suggestionBackground: '#373737',
    suggestionText: '#fcfcfc',
    pauseButton: '#ffffff',
    pauseIcon: '#e4002b',
    gearIcon: '#FCFCFC',
    microphoneIcon: '#ffffff',
    feedbackIcon: '#ffffff',
    feedbackDialogBg: '#373737',
    feedbackDialogBorder: 'rgba(255,255,255,0.1)',
    feedbackDialogTitleText: '#ffffff',
    feedbackDialogText: '#ffffff',
    feedbackDialogButtonBg: 'rgba(0,0,0,0.15)',
    feedbackDialogInputBg: 'rgba(0,0,0,0.15)',
    feedbackDialogBackBg: 'rgba(255,255,255,0.05)',
    feedbackDialogCloseBg: '#3d3d3d',
    timestampText: '#858585',
    visitLinkText: '#ffffff',
    spinnerDot: '#d9d9d9',
    spinnerTrack: '#f3f3f3',
    loaderPillBg: '#373737',
    pageBg: '#121212',
    triggerIconColor: '#ffffff',
    checklistIconColor: '#FCFCFC',
    checklistBorder: '#858585',
    checklistProgressTrack: '#8C827966',
    checklistCheckboxBorder: 'rgba(255, 255, 255, 0.7)',
    checklistCheckmark: '#ffffff',
    checklistButtonBg: '#121212',
    checklistButtonText: '#ffffff',
    checklistDoneBg: '#781044',
    checklistHeaderText: '#ffffff',
    checklistTriggerBg: '#121212',
    checklistTriggerText: '#ffffff',
    signoutIcon: '#ffffff',
    imageArrowBackground: 'rgba(0, 0, 0, 0.5)',
    imageArrowText: '#ffffff',
    metadataBubbleText: '#ffffff',
    metadataBubbleSubtleBg: 'rgba(255, 255, 255, 0.05)',
    checklistHeaderBg: '#222222',
    checklistText: '#ffffff',
    languageLabelText: '#777777',
    settingsModalBg: '#222222',
    settingsText: '#ffffff',
    settingsInactiveTabText: '#ffffff',
    topBarBorder: '#464240',
    topBarBg: '#121212',
    formControlBg: '#2b2b2b',
    formControlText: '#ffffff',
  },
  logo: defaultLogo,
  avatar: defaultAvatar,
  poweredByLogo: defaultPoweredByLogo,
  avatarOutline: {
    color: 'transparent',
    width: 0,
  },
  aiMessageOutline: {
    color: 'transparent',
    width: 0,
  },
  userMessageOutline: {
    color: 'transparent',
    width: 0,
  },
  promptOutline: {
    color: 'transparent',
    width: 0,
  },
  imageOutline: {
    color: 'transparent',
    width: 0,
  },
  playbackPillOutline: {
    color: 'transparent',
    width: 0,
  },
  checklistTriggerOutline: {
    color: 'transparent',
    width: 1,
  },
  translations: {},
};
